import React from 'react';
import {
  Box,
  constants
} from '@match/react-component-library';
import { Logo } from '../../../app-core-components/Logo';

export interface HeaderProps {
  dark: boolean;
  desktop: boolean;
}

const getBackgroundColor = (dark: boolean, desktop: boolean)  => {
  if (desktop || dark) {
    return constants.SEMANTIC_COLOR_NAME.PRIMARY1;  
  } else {
    return constants.SEMANTIC_COLOR_NAME.LIGHT;
  }
}

const getLogoColor = (dark: boolean, desktop: boolean) => {
  if (desktop || dark) {
    return constants.SEMANTIC_COLOR_NAME.LIGHT;
  } else {
    return constants.SEMANTIC_COLOR_NAME.PRIMARY1;
  }
}

const Header: React.FC<HeaderProps> = ({
  dark,
  desktop
}) => {
  return (
    <Box
      alignItems="center"
      backgroundColor={getBackgroundColor(dark, desktop)}
      display="flex"
      minHeight={56}
      height={56}
      paddingX="large"
      width="100%"
    >
      <Logo width={83} height={23} color={getLogoColor(dark, desktop)} />
    </Box>
  );
};

export default Header;